// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"OriginDestinationHorizontal-module__wrapper___WgqqT"};